module.exports = __webpack_public_path__ + "img/background_mask.91ff7f97.png";